import KendoButton from '../KendoButton'
import KendoButtonGroup from '../KendoButtonGroup'
import KendoButtonGroupButton from '../KendoButtonGroup/KendoButtonGroupButton'
import KendoToolBar from '../KendoToolBar'
import KendoToolBarItem from '../KendoToolBar/KendoToolBarItem'

let KendoButtonsInstaller = class {
    static install(Vue) {
        Vue.component(KendoButton.name, KendoButton)
        Vue.component(KendoButtonGroup.name, KendoButtonGroup)
        Vue.component(KendoButtonGroupButton.name, KendoButtonGroupButton)
        Vue.component(KendoToolBar.name, KendoToolBar)
        Vue.component(KendoToolBarItem.name, KendoToolBarItem)
    }
}

export default KendoButtonsInstaller

// Automatic installation if Vue has been added to the global scope.
if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(KendoButtonsInstaller)
}


// WEBPACK FOOTER //
// ./packages/kendo-buttons-vue-wrapper/src/kendo-buttons-installer/index.js